"use strict";

// eslint-disable-next-line func-names
module.exports = function payloadReducer(payloadKey, defaultValue) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultValue;
    var action = arguments[1];
    var type = action.type,
        payload = action.payload;


    if (type === payloadKey) {
      state = payload;
    }

    return state;
  };
};